import { DietCreateForm, DietImages } from 'types/diet';
import { ImageFields, ImagePreset } from 'types/photo';

export type DietFormValuesProps = DietCreateForm & {
  [K in `guaranty_${number}`]: string;
} & {
  google: string;
  yandex: string;
};

export enum DIET_TAB_VALUES {
  INFO = 'info',
  STYLING = 'styling',
}

export const MAX_GUARANTIES = 10;
export const MAX_TEXT_LENGTH = 255;
export const MIN_TEXT_LENGTH = 3;
export const MAX_CALORIES = 10000;

export const DIET_IMAGES_PRESETS: Record<keyof DietImages, ImagePreset> = {
  [ImageFields.COVER]: {
    width: 840,
    height: 344,
    title: 'Карточная обложка (для совместимости)',
  },
  [ImageFields.COVER_MOBILE]: {
    width: 840,
    height: 344,
    title: 'Карточная обложка мобильная версия',
  },
  [ImageFields.COVER_DESKTOP]: {
    width: 752,
    height: 308,
    title: 'Карточная обложка ПК версия',
  },
  [ImageFields.DESKTOP]: {
    width: 2328,
    height: 646,
    title: 'Детальная информация: ПК версия',
  },
  [ImageFields.MOBILE]: {
    width: 888,
    height: 700,
    title: 'Детальная информация: мобильная версия',
  },
};

export const PDF_IMAGES_PRESETS: Record<keyof DietImages, ImagePreset> = {
  [ImageFields.COVER]: {
    width: 436,
    height: 474,
    title: 'Карточная обложка (для совместимости)',
  },
  [ImageFields.COVER_MOBILE]: {
    width: 436,
    height: 474,
    title: 'Карточная обложка мобильная версия',
  },
  [ImageFields.COVER_DESKTOP]: {
    width: 440,
    height: 480,
    title: 'Карточная обложка ПК версия',
  },
  [ImageFields.DESKTOP]: {
    width: 2328,
    height: 646,
    title: 'Детальная информация: ПК версия',
  },
  [ImageFields.MOBILE]: {
    width: 888,
    height: 700,
    title: 'Детальная информация: мобильная версия',
  },
};
